export const blackList = ['9720523949888', '9720528334413', '9720586667212', '9720548147707', '972523949888', '972528334413', '972586667212', '972548147707'];
